import KeyValue from "./KeyValue";

export default function KeyValueList({ data, sort = false, options = null }) {
  const isArray = Array.isArray(data);
  return (
    <div className="flex flex-col gap-1">
      {Object.entries(data)
        .sort(([a], [b]) => (sort ? a.localeCompare(b) : 0))
        .map(([k, v], index) => (
          <KeyValue
            index={index}
            isArray={isArray}
            key={k}
            label={k}
            value={String(v)}
            onClickFunction={options?.[k]?.onClickFunction}
          />
        ))}
    </div>
  );
}
